module.exports = __webpack_public_path__ + "static/media/Audience@3x.3463a9ab.png";